import HCheckArray from "./check-have-value";

export const HGetValueFromArray = (array: any[], key: string) => {
  if (HCheckArray(array)) {
    return array[0][key];
  }
  return [];
};
